import { AsyncActionCreator } from '../types';
import { createAsyncAction } from '../utils';

import { ActionType, GetCountriesAction } from './types';

export const getCountries: AsyncActionCreator<
  GetCountriesAction,
  () => Record<string, never>
> = createAsyncAction<GetCountriesAction>({
  request: ActionType.GET_COUNTRIES_REQUEST,
  success: ActionType.GET_COUNTRIES_SUCCESS,
  failure: ActionType.GET_COUNTRIES_FAILURE,
})();
